import { render, staticRenderFns } from "./LocPersonal.vue?vue&type=template&id=1a3aef1f&scoped=true"
import script from "./LocPersonal.vue?vue&type=script&lang=js"
export * from "./LocPersonal.vue?vue&type=script&lang=js"
import style0 from "./LocPersonal.vue?vue&type=style&index=0&id=1a3aef1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3aef1f",
  null
  
)

export default component.exports